import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { lazy, Suspense, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isUserAuthorized } from "./store/selectors";
import { checkToken, exchangeSsoToken, loadInitialData } from "./actions/authActions";
import { Loading } from "./layout/utils/AppLoading";
import withClearCache from "./ClearCache";

const MainContainer = lazy(() => import("./containers/MainContainer"));
const AuthContainer = lazy(() => import("./containers/AuthContainer"));

const takeSsoTokenFromUrl = () => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get("sso_token");
  if (!token) return null;
  url.searchParams.delete("sso_token");
  window.history.replaceState(
    window.history.state,
    "",
    `${url.pathname}${url.search}${url.hash}`
  );
  return token;
};

const initialSsoToken = takeSsoTokenFromUrl();

const App = () => {
  const dispatch = useDispatch();
  const [ssoPending, setSsoPending] = useState(Boolean(initialSsoToken));

  const { auth } = useSelector(isUserAuthorized) || {};

  const fetchInitialData = useCallback(() => {
    dispatch(loadInitialData());
  }, [dispatch]);

  const checkPersistency = useCallback(() => {
    dispatch(checkToken());
  }, [dispatch]);

  const ClearCacheComponent = withClearCache(() => {
    return <></>;
  });

  useEffect(() => {
    if (auth) {
      fetchInitialData();
      return;
    }
    if (ssoPending && initialSsoToken) {
      dispatch(exchangeSsoToken(initialSsoToken)).finally(() => setSsoPending(false));
      return;
    }
    checkPersistency();
  }, [auth, checkPersistency, dispatch, fetchInitialData, ssoPending]);

  if (ssoPending) {
    return <Loading centered />;
  }

  return (
    <Suspense fallback={<Loading centered />}>
      <ClearCacheComponent />
      {auth ? <MainContainer /> : <AuthContainer />}
    </Suspense>
  );
};

export default App;
